import { FormattedMessage } from "react-intl"

const UITranslator = ({ id, ...props }) =>
{
    return <FormattedMessage id={id} {...props} />
}

export default UITranslator
